// @flow

import React, { Component } from 'react';
import { Field } from 'redux-form';

import FormFieldRadioGroup from './FormFieldRadioGroup';
import { validate } from 'redux-form-jsonschema-reactstrap';

import RadioButton from '@material-ui/core/Radio';
import TextField from '@material-ui/core/TextField';

// WORKS WITH AN OLDER VERSION ON MATERIAL-UI

class InputComponent extends Component {
  static defaultProps = {
    schemaVis: {}
  };
  props: {
    type: string,
    schemaVis: {
      schema: { [string]: any }
    },
    input: { name: string },
    meta: { [string]: any },
    children: [React.Element<*>],
    classes: { [string]: any },
    styles: { [string]: any },
    sheet: any
  };

  renderInput() {
    const {
      //classes,
      styles,
      sheet,
      type,
      input,
      schemaVis,
      meta,
      children,
      ...rest
    } = this.props;
    const classes = { input: ''}
    const attributes = {
      className: classes.input,
      id: input.name,
      type,
      ...input,
      ...rest
    };
    return (
      <TextField {...attributes} />
      );
  }

  render() {
    const { schemaVis: { schema }, type, ...rest } = this.props;
    return (
      <FormFieldRadioGroup schema={schema} classes={{formGroup:''}} {...rest}>
        {this.renderInput()}
      </FormFieldRadioGroup>
    );
  }
}

export class InputField extends Component<*, *, *> {
  static defaultProps = {
    component: InputComponent,
    required: false,
    schemaVis: {}
  };

  props: {
    schemaVis: {
      schema: any
    },
    component: any,
    type: string,
    name: string,
    required: boolean,
    classes: { [string]: any }
  };

  validate = (value, allValues, props, name) => {
    const { schemaVis: { schema }, required } = this.props;
    return validate(schema, required)(value, allValues, props, name);
  }

  render() {
    const {
      schemaVis,
      name,
      component,
      required,
      ...rest
    } = this.props;
    const min = schemaVis.schema.minimum || 0;
    const max = schemaVis.schema.maximum || 10;
    const step = schemaVis.schema.step || 1;
    //const value = schemaVis.schema.default || undefined
    var items = []
    for (var i = min; i <= max; i = i + step) {
        items.push(<RadioButton value={i} label={i} key={i} />)
    }

    return (
      <Field
        name={name}
        schemaVis={schemaVis}
        required={required}
        component={InputComponent}
        validate={this.validate}
        {...rest}
      >
      </Field>
    );
  }
}

function select(_options: CreateInputOptionsType) {
  const { styles, ...options } = _options;
  class CreatedInputField extends Component {
    render() {
      return <InputField {...this.props} {...options} />;
    }
  }

  return CreatedInputField;
}

export default select({})
